export const getAvatarColor = function(userId) {
  const colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'cyan', 'teal', 'green', 'orange']

  const index = userId % colors.length
  return colors[index]
}
